export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Walls',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Walls',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Walls Nível 1',
      invalid: 'Nome é obrigatório',
    },
    showAnswer: {
      label: 'Mostrar resposta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Colunas:',
    },
    rows: {
      label: 'Linhas:',
    },
    level: {
      label: 'Nível:',
      placeholder: 'Selecione o nível...',
      invalid: 'Nível é obrigatório',
      tooltip:
        'O nível influencia a geração do jogo, mas você pode alterá-lo livremente sem precisar gerar um novo.',
    },
  },
  button: {
    generate: 'Gerar Jogo',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'walls',
  },
  alert: {
    generated: 'Puzzle gerado com sucesso!',
    bestPuzzle: 'Melhor puzzle: {junk} célula(s) de lixo.',
    generateFailed: 'Erro na geração.',
    workerCritical: 'Erro interno nos workers.',
    gameSaved: 'Jogo salvo com sucesso!',
    workerErrors: {
      noValidPuzzle: 'Não foi possível gerar nenhum puzzle válido.',
    },
  },
};
